import React, { memo } from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

export const InventoryCardSkeleton = memo(() => (
  <div className="inventory-card-skeleton bg-transparent mt-1">
    <Skeleton className="d-block height-200 rounded-top-left-16 rounded-top-right-16" />
    <div className="px-1">
      <div className="my-1_5">
        <Skeleton className="d-block mb-0_5 rounded-6 height-22" />
        <Skeleton className="d-block rounded-6 height-22" />
      </div>
      <Skeleton className="d-block rounded-6 w-60 height-16 mb-1" />
      <Skeleton className="d-block rounded-6 w-75 height-16 mb-1" />
      <Skeleton className="d-block rounded-6 w-70 height-16 mb-1" />
      <Skeleton className="d-block rounded-6 w-30 height-16 mb-1" />
      <Skeleton className="d-block rounded-6 height-40 mt-0_5" />
    </div>
  </div>
));

InventoryCardSkeleton.displayName = 'InventoryCardSkeleton';
